export const defaultStyle = {
	videoWrapper: 'videoWrapper w-full lg:w-[50%] lg:px-30 relative block',
}

export const QUARTER_WIDTH_VIDEO_WRPR = {
	videoWrapper: 'videoWrapper w-full relative block',
}

export const NEWSPAGE_DETAIL_VIDEO = {
	videoWrapper: 'videoWrapper w-full relative ',
}

export const HALF_WIDTH_VIDEO_WRPR = {
	videoWrapper: 'videoWrapper w-full lg:w-1/2 lg:px-30 relative block overflow-hidden',
}

export const TWO_COL_6_WIDTH = {
	videoWrapper: 'videoWrapper w-full lg:px-30 relative block',
}

export const TWO_COL_6_WIDTH_HOMEPAGE = {
	videoWrapper: 'videoWrapper w-full lg:w-full relative block',
}

export const VIDEO_ALIGN = {
	...TWO_COL_6_WIDTH,
	videoWrapper: "videoWrapper top-[100px] w-full lg:w-[50%] lg:px-30 relative block",
}

export const FULL_WIDTH = {
}
export const THREE_COL_VIDEO_WRAP = {
	videoWrapper: 'videoWrapper  w-full md:mb-20', 
}

export const CAREER_VIDEO_BANNER = {
	videoWrapper: 'videoWrapper w-full relative block',
}

export const VIDEO_WITH_IMAGE_WITH_TEXT = {
	videoWrapper: 'relative bottom-[40px] left-[0] top-0 videoWrapper w-full lg:px-30 block overflow-hidden',
}
export const TWO_COL_6_WIDTH_IMAGE_CONTAIN = {	
	videoWrapper: 'videoWrapper w-full relative'
}